import React from 'react';
import { TypedMemo } from '../../common/types';
import { SMLDeletePageModalProps } from './props';
import { SMLDeletePageSheet } from './SMLDeletePageSheet';

/**
 * The dialog's shell.
 *
 * The body is mounted only while the dialog is open: it reads the page's stats
 * and its campaign to count what the deletion costs, and neither is worth
 * fetching for a dialog nobody has opened.
 */
const SMLDeletePageModalComponent: React.FC<SMLDeletePageModalProps> = ({
  isOpen,
  accountId,
  smartLink,
  closeModal,
  onDelete,
  isDeleting = false,
  error,
}) =>
  isOpen && smartLink !== undefined ? (
    <SMLDeletePageSheet
      accountId={accountId}
      smartLink={smartLink}
      closeModal={closeModal}
      onDelete={onDelete}
      isDeleting={isDeleting}
      error={error}
    />
  ) : null;

export const SMLDeletePageModal = TypedMemo(SMLDeletePageModalComponent);
